import { useDispatch, useSelector } from "react-redux";
import Topbar from "../../layouts/topbar";
import Webmenu from "../../layouts/webmenu";
import { useEffect } from "react";
import { getAllInvestigation } from "../../actions/InvestigationActions";
import { Link, useNavigate } from "react-router-dom";
import { getDashboard } from "../../actions/DashboardActions";
import { ThreeDots } from "react-loader-spinner";
import { useState } from "react";
import ReactApexChart from "react-apexcharts";
import Mobilemenu from "../../layouts/mobile-menu";

function Dashboard() {

    const user = useSelector(state => state?.auth?.userData);
    const loggedIn = useSelector(state => state?.auth?.loggedIn);

    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getDashboard());
    }, []);

    const dashboard = useSelector(state => state?.dashboard?.dashboard);
    const loading = useSelector(state => state?.loading?.loading);

    const generateRandomFluctuations = (baseValue, count) => {
        return Array.from({ length: count }, (_, index) => ({
            x: new Date(`2020-01-${index + 1}`).getTime(),
            y: baseValue + Math.floor(Math.random() * 10) - 5, // Random fluctuations between -5 and 5
        }));
    };

    const dates = generateRandomFluctuations(15, 12); // Adjust count and baseValue as needed

    const [lineChart, setLineChart] = useState({
        series: [{
            name: 'XYZ MOTORS',
            data: dates
        }],
        options: {
            chart: {
                type: 'area',
                stacked: false,
                height: 350,
                zoom: {
                    type: 'x',
                    enabled: true,
                    autoScaleYaxis: true
                },
                toolbar: {
                    autoSelected: 'zoom'
                }
            },
            dataLabels: {
                enabled: false
            },
            markers: {
                size: 0,
            },
            fill: {
                type: 'gradient',
                gradient: {
                    shadeIntensity: 1,
                    inverseColors: false,
                    opacityFrom: 0.5,
                    opacityTo: 0,
                    stops: [0, 90, 100]
                },
            },
            yaxis: {
                labels: {
                    formatter: function (val) {
                        return val.toFixed(0);
                    },
                },
                title: {
                    text: 'Count'
                },
            },
            xaxis: {
                type: 'datetime',
            },
            colors: ['#2d3748'],
            tooltip: {
                shared: false,
                y: {
                    formatter: function (val) {
                        return val.toFixed(0);
                    }
                }
            }
        }
    });

    // Polar Are Chart
    const categories = ['Category 1', 'Category 2', 'Category 3', 'Category 4', 'Category 5'];
    const data = [20, 30, 25, 40, 15]; // Adjust data as needed

    const [polarChart, setPolarChart] = useState({
        series: data,
        options: {
            chart: {
                type: 'polarArea',
            },
            fill: {
                opacity: 1,
                gradient: {
                    shade: 'light',
                    type: 'vertical',
                    shadeIntensity: 0.5,
                    gradientToColors: undefined,
                    inverseColors: false,
                    opacityFrom: 1,
                    opacityTo: 0.8,
                    stops: [0, 100],
                },
            },
            stroke: {
                width: 0,
            },
            plotOptions: {
                polarArea: {
                    rings: {
                        strokeWidth: 1,
                        strokeColor: '#ccc',
                    },
                },
            },
            yaxis: {
                show: false,
            },
            responsive: [
                {
                    breakpoint: 480,
                    options: {
                        chart: {
                            height: 300,
                        },
                    },
                },
            ],
        },
    });

    return (
        <span>
            <Mobilemenu />
            <div className="content-body d-flex">
                <Webmenu />
                <div className="content">
                    <Topbar />
                    {
                        loading ?
                            <ThreeDots
                                height="80"
                                width="80"
                                radius="9"
                                color="#2d3748"
                                ariaLabel="three-dots-loading"
                                wrapperStyle={{ justifyContent: 'center', alignItems: 'center', height: '100%' }}
                                wrapperClassName=""
                                visible={loading}
                            /> :
                            <span>
                                <div class="grid columns-12 gap-6">
                                    <div class="g-col-12 g-col-xxl-9">
                                        <div class="grid columns-12 gap-6">
                                            {/* <!-- BEGIN: General Report --> */}
                                            <div class="g-col-12 mt-8">
                                                <div class="intro-y d-flex align-items-center h-10">
                                                    <h2 class="fs-lg fw-medium truncate me-5">
                                                        General Report
                                                    </h2>
                                                    <a href="" class="ms-auto d-flex align-items-center text-theme-1 dark-text-theme-10"> <i data-feather="refresh-ccw" class="w-4 h-4 me-3"></i> Reload Data </a>
                                                </div>
                                                <div class="grid columns-12 gap-6 mt-5">
                                                    <div class="g-col-12 g-col-sm-6 g-col-xl-3 intro-y">
                                                        <Link to={`/investigation`}>
                                                            <div class="report-box zoom-in">
                                                                <div class="box p-5">
                                                                    <div class="d-flex">
                                                                        <div className="text-theme-1">
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-search w-8 h-8"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
                                                                        </div>
                                                                    </div>
                                                                    <div class="report-box__total fs-3xl fw-medium mt-6">{dashboard?.investigation_count}</div>
                                                                    <div class="fs-base text-gray-600 mt-1">Investigations</div>
                                                                </div>
                                                            </div>
                                                        </Link>
                                                    </div>
                                                    <div class="g-col-12 g-col-sm-6 g-col-xl-3 intro-y">
                                                        <Link to={`/estimates`}>
                                                            <div class="report-box zoom-in">
                                                                <div class="box p-5">
                                                                    <div class="d-flex">
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-sliders text-theme-11 w-8 h-8"><line x1="4" y1="21" x2="4" y2="14"></line><line x1="4" y1="10" x2="4" y2="3"></line><line x1="12" y1="21" x2="12" y2="12"></line><line x1="12" y1="8" x2="12" y2="3"></line><line x1="20" y1="21" x2="20" y2="16"></line><line x1="20" y1="12" x2="20" y2="3"></line><line x1="1" y1="14" x2="7" y2="14"></line><line x1="9" y1="8" x2="15" y2="8"></line><line x1="17" y1="16" x2="23" y2="16"></line></svg>
                                                                    </div>
                                                                    <div class="report-box__total fs-3xl fw-medium mt-6">{dashboard?.estimate_count}</div>
                                                                    <div class="fs-base text-gray-600 mt-1">Estimates</div>
                                                                </div>
                                                            </div>
                                                        </Link>
                                                    </div>
                                                    <div class="g-col-12 g-col-sm-6 g-col-xl-3 intro-y">
                                                        <Link to={`/jobCard`}>
                                                            <div class="report-box zoom-in">
                                                                <div class="box p-5">
                                                                    <div class="d-flex">
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-file w-8 h-8 text-theme-9"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>
                                                                    </div>
                                                                    <div class="report-box__total fs-3xl fw-medium mt-6">{dashboard?.jobCard_count}</div>
                                                                    <div class="fs-base text-gray-600 mt-1">Job Cards</div>
                                                                </div>
                                                            </div>
                                                        </Link>
                                                    </div>
                                                    <div class="g-col-12 g-col-sm-6 g-col-xl-3 intro-y">
                                                        <Link to={`/customers`}>
                                                            <div class="report-box zoom-in">
                                                                <div class="box p-5">
                                                                    <div class="d-flex">
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-package me-1 w-8 h-8 text-theme-6"><line x1="16.5" y1="9.4" x2="7.5" y2="4.21"></line><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line></svg>

                                                                        {/* <div class="ms-auto">
                                                        <div class="report-box__indicator bg-theme-9 tooltip cursor-pointer" title="12% Higher than last month"> 12% <i data-feather="chevron-up" class="w-4 h-4 ms-0.5"></i> </div>
                                                    </div> */}
                                                                    </div>
                                                                    <div class="report-box__total fs-3xl fw-medium mt-6">{dashboard?.customer_count}</div>
                                                                    <div class="fs-base text-gray-600 mt-1">Total Customers</div>
                                                                </div>
                                                            </div>
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <!-- END: General Report --> */}
                                        </div>
                                    </div>
                                    <div class="g-col-12 g-col-xxl-3">
                                        <div class="border-start-xxl border-theme-5 dark-border-dark-3 mb-n10 pb-10">
                                            <div class="ps-xxl-6 grid grid-cols-12 gap-6">
                                                {/* <!-- BEGIN: Transactions --> */}
                                                <div class="g-col-12 g-col-md-12 g-col-xl-4 g-col-xxl-12 mt-3 mt-xxl-8">
                                                    <div class="intro-x d-flex align-items-center h-10">
                                                        <h2 class="fs-lg fw-medium truncate me-5">
                                                            Recent Investigations
                                                        </h2>
                                                    </div>
                                                    <div class="mt-5">
                                                        {
                                                            dashboard?.investigation && dashboard?.investigation.length > 0 &&
                                                            dashboard?.investigation.slice(0, 3).map(investigation => {
                                                                return (
                                                                    <div class="intro-x">
                                                                        <div class="box px-5 py-3 mb-3 d-flex align-items-center zoom-in">
                                                                            <div className="w-2 h-2 bg-theme-11 rounded-circle me-3"></div>
                                                                            <div class="ms-4 me-auto">
                                                                                <div class="fw-medium">{investigation?.customer_name}</div>
                                                                                <div class="text-gray-600 fs-xs mt-0.5">{investigation?.vehicle?.plate_number}</div>
                                                                            </div>

                                                                            <div className="d-flex flex-column align-items-center ">
                                                                                <div className="fs-xs text-gray-500 ms-auto">{investigation?.service_date}</div>
                                                                                <div class="text-theme-9">DH {investigation?.total_amount}</div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )
                                                            })

                                                        }
                                                        <Link to="/investigation">
                                                            <a href="" class="intro-x w-full d-block text-center rounded-2 py-3 border border-dotted border-theme-15 dark-border-dark-5 text-theme-16 dark-text-gray-600">View More</a>
                                                        </Link>
                                                    </div>
                                                </div>
                                                {/* <!-- END: Transactions --> */}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="g-col-12 g-col-xxl-6">
                                        <h2 class="fs-lg fw-medium truncate mb-2">
                                            Investigations Done
                                        </h2>
                                        <div id="chart" className="box p-3">
                                            <ReactApexChart options={lineChart.options} series={lineChart.series} type="area" height={350} />
                                        </div>
                                    </div>
                                    <div class="g-col-12 g-col-xxl-6">
                                        <h2 class="fs-lg fw-medium truncate mb-2">
                                            Weekly Progress
                                        </h2>
                                        <div id="polar-chart" className="box p-3">
                                            <ReactApexChart options={polarChart.options} series={polarChart.series} type="polarArea" height={350} />
                                        </div>
                                    </div>
                                </div>
                            </span>
                    }
                </div>
            </div>
        </span>
    )
}

export default Dashboard;